import { MEmailBlock } from '../../mdl/m-template';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { EDEmailEditor } from './editor';

export const ed_email_hr_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'hr',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            super($form({}), container, 'Separator');

            this.ui_add($el.DIV('tl-email-hr', $el.DIV('r-hr')));
        }
    },
}
